// extracted by mini-css-extract-plugin
module.exports = {"page":"core-exchange_page__hVAuI"};